import { render, staticRenderFns } from "./CustomerFormats.vue?vue&type=template&id=49fc479e&"
import script from "./CustomerFormats.vue?vue&type=script&lang=js&"
export * from "./CustomerFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports